import loadable from '@loadable/component';

export const BikeperfectSiteWrapper = loadable(
  () => import(/* webpackChunkName: "bikeperfect-site" */ './BikeperfectSiteWrapper'),
);
